import React, { useEffect, useState } from 'react';

import poster01 from '../../../Assets/Linkages/InternationalConferences/ICASE-Legacy-01.jpg';
import poster02 from '../../../Assets/Linkages/InternationalConferences/ICASE-Legacy-02.jpg';
import poster03 from '../../../Assets/Linkages/InternationalConferences/ICASE-Legacy-03.jpg';
import poster04 from '../../../Assets/Linkages/InternationalConferences/ICASE-Legacy-04.jpg';

const posters = [poster01, poster02, poster03, poster04];

const getVisibleCount = () => {
  if (window.innerWidth < 680) return 1;
  if (window.innerWidth < 1050) return 2;
  return 3;
};

const ICASELegacy = () => {
  const [start, setStart] = useState(0);
  const [visible, setVisible] = useState(getVisibleCount);

  useEffect(() => {
    const resize = () => setVisible(getVisibleCount());
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => setStart((current) => (current + 1) % posters.length), 3000);
    return () => window.clearInterval(timer);
  }, []);

  const shown = Array.from({ length: visible }, (_, index) => posters[(start + index) % posters.length]);

  return (
    <section className="icase-legacy" aria-labelledby="icase-legacy-title">
      <div className="icase-legacy-inner">
        <p className="section-eyebrow">A LEGACY OF AEROSPACE EXCELLENCE</p>
        <h2 id="icase-legacy-title">Our Legacy</h2>
        <div className="icase-title-line" aria-hidden="true" />
        <div className="icase-legacy-slider" aria-live="off">
          {shown.map((poster, index) => (
            <figure className="icase-legacy-poster" key={`${start}-${index}`}>
              <img src={poster} alt={`ICASE legacy poster ${((start + index) % posters.length) + 1}`} loading="lazy" />
            </figure>
          ))}
        </div>
        <div className="icase-introduction-controls">
          <button type="button" onClick={() => setStart((start - 1 + posters.length) % posters.length)} aria-label="Previous legacy posters">←</button>
          <span>{String(start + 1).padStart(2, '0')} / {posters.length}</span>
          <button type="button" onClick={() => setStart((start + 1) % posters.length)} aria-label="Next legacy posters">→</button>
        </div>
      </div>
    </section>
  );
};

export default ICASELegacy;
